// extracted by mini-css-extract-plugin
export default {"feature":"Feature_feature__DoxTY","article":"Feature_article__qBON8","feature1":"Feature_feature1__Cox-b","feature2":"Feature_feature2__aTvt9","feature3":"Feature_feature3__Ik415"};